import { render, staticRenderFns } from "./BreakStartModal.vue?vue&type=template&id=242fcd90&scoped=true"
import script from "./BreakStartModal.vue?vue&type=script&lang=js"
export * from "./BreakStartModal.vue?vue&type=script&lang=js"
import style0 from "./BreakStartModal.vue?vue&type=style&index=0&id=242fcd90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242fcd90",
  null
  
)

export default component.exports